import { 
    CHANGE_PCT_NOTIFIER,
    CHANGE_SENT_PCT_RESULT,
    DOWNLOAD_MULTIPLE_PCT_EXCEL,
    DOWNLOAD_MULTIPLE_PCT_EXCEL_SUCCESS,
    DOWNLOAD_MULTIPLE_PCT_PDF,
    DOWNLOAD_MULTIPLE_PCT_PDF_SUCCESS,
    DOWNLOAD_PCT_EXCEL,
    DOWNLOAD_PCT_EXCEL_SUCCESS,
    GET_PCT_INFO,
    GET_PCT_INFO_LIST,
    GET_PCT_INFO_LIST_SUCCESS,
    GET_PCT_INFO_LIST_SUCCESS_UNLOCK,
    GET_PCT_INFO_SUCCESS,
    GET_PCT_NOTIFIER_SETTINGS,
    GET_PCT_NOTIFIER_SETTINGS_SUCCESS,
    MULTIPLE_HIDE_PCT,
    MULTIPLE_STAR_PCT,
    MULTIPLE_UNHIDE_PCT,
    MULTIPLE_UNSTAR_PCT,
    PREVIEW_PCT_EMAIL,
    PREVIEW_PCT_EMAIL_SUCCESS,
    SAVE_PCT_NOTIFIER_SETTINGS, 
    SAVE_PCT_NOTIFIER_SETTINGS_SUCCESS, 
    SEND_PCT_EMAIL, 
    SEND_PCT_EMAIL_SUCCESS, 
    SET_PCT_LOADING,
    SET_PCT_RESULTS,
    SET_PCT_SENT_SUCCESS,
    SET_PCT_SETTINGS,
    SET_PCT_SUCCESS,
    SET_PREVIEW_PCT_EMAIL,
    SET_UPGRADE_ALERT_MESSAGE,
    UNLOCK_PCT
} from "./actionTypes";

const initialStates = {
  pctSearchSettings : {},
  loading: false,
  result : -1,
  userGrade: "00",
  success: "",
  pctInfo: [],
  pctInfoTotalPages: 0,
  noticeStr: "",
  previewEmail: [],
  previewPctPdfList: [],
  sentSuccess:"",
  sentCnt: 0,
  unsubsEmails: [],
  disableEmails: [],
  sentIn24Emails: [], 
  upgradeAlertMessage: {title:"",text:""},
  autoSearch: "N",
  isPctSearched: false,
  sentIn5DaysEmails : [],
  userActiveSub: 0,
}

const pctNotifier = (state = initialStates, action) => {
    switch(action.type){
        case SAVE_PCT_NOTIFIER_SETTINGS:
            return {
                ...state,
                loading: true
            }
        case SAVE_PCT_NOTIFIER_SETTINGS_SUCCESS:
            return {
                ...state,
                pctSearchSettings: action.payload,
                success: action.payload.result,
                loading: false
            }
        case GET_PCT_NOTIFIER_SETTINGS:
            return {
                ...state,
                loading: true
            }
        case GET_PCT_NOTIFIER_SETTINGS_SUCCESS:
            return {
                ...state,
                pctSearchSettings: action.payload.pctSearchSettings,
                userGrade: action.payload.userGrade,
                autoSearch: action.payload.autoSearch,
                userActiveSub: action.payload.userActiveSub,
                loading: false
            }
        case SET_PCT_LOADING:
            return {
                ...state,
                loading: action.payload
            }
        case SET_PCT_SUCCESS:
            return {
                ...state,
                success: action.payload
            }
        case GET_PCT_INFO:
            return {
                ...state,
                loading: true
            }
        case GET_PCT_INFO_SUCCESS:
            return {
                ...state,
                pctInfo: action.payload.pctInfo,
                pctInfoTotalPages: action.payload.totalPages,
                noticeStr: action.payload.noticeStr,
                userGrade: action.payload.userGrade,
                userActiveSub: action.payload.userActiveSub,
                loading: false
            }
        case MULTIPLE_STAR_PCT:
            return{
                ...state
            }
        case MULTIPLE_UNSTAR_PCT:
            return{
                ...state
            }
        case MULTIPLE_HIDE_PCT:
            return{
                ...state
            }
        case MULTIPLE_UNHIDE_PCT:
            return{
                ...state
            }
        case GET_PCT_INFO_LIST:
            return {
                ...state,
                loading: false
            }
        case GET_PCT_INFO_LIST_SUCCESS:
            if(action.payload.pctInfo.length > 0){
                let _newPctInfo = []
                state.pctInfo.map((pct,index)=>{
                    let isChanged = false;
                    action.payload.pctInfo.map((newPct)=>{
                        if(pct.pubNumber == newPct.pubNumber){
                            isChanged = true;
                           
                            _newPctInfo.push({
                                ...newPct,
                                npePredictionNpeCount: newPct.npePredictionNpeCount != null ? newPct.npePredictionNpeCount : pct.npePredictionNpeCount,
                                npePredictionSampleSize: newPct.npePredictionSampleSize != null ? newPct.npePredictionSampleSize : pct.npePredictionSampleSize,
                            })
                            
                        }
                    })
                    if(!isChanged){
                        _newPctInfo.push(pct)
                    }
                })
                return{
                    ...state,
                    pctInfo: _newPctInfo,
                    loading: false
                }
            }
        case CHANGE_PCT_NOTIFIER:
            return {
                ...state,
                pctInfo: action.payload
            }
        case SET_PCT_RESULTS:
            return {
                ...state,
                loading: false,
                result: action.payload
            }
        case UNLOCK_PCT:
            return {
                ...state,
                loading: true
            }
        case GET_PCT_INFO_LIST_SUCCESS_UNLOCK:
            if (action.payload.pctInfo.length > 0) {
                let _newPctNotifier = [];
                state.pctInfo.map((pct, index) => {
                  let isChange = false;
                  action.payload.pctInfo.map((newPct, index2) => {
                    if (pct.repRankCode == newPct.repRankCode) {
                      isChange = true;
                      
                      _newPctNotifier.push({
                        ...newPct,
                        npePredictionNpeCount: newPct.npePredictionNpeCount != null ? newPct.npePredictionNpeCount : pct.npePredictionNpeCount,
                        npePredictionSampleSize: newPct.npePredictionSampleSize != null ? newPct.npePredictionSampleSize : pct.npePredictionSampleSize,
                      });
                    }
                  });
        
                  if (!isChange) {
                    _newPctNotifier.push(pct);
                  }
                });
        
                return {
                  ...state,
                  pctInfo: _newPctNotifier,
                  loading: false,
                }
              } else {
                return {
                  ...state,
                  loading: false,
                }
              }
        case DOWNLOAD_PCT_EXCEL:
            return {
                ...state,
                loading: true
            }
        case DOWNLOAD_PCT_EXCEL_SUCCESS:
            return {
                ...state,
                loading: false
            }
        case DOWNLOAD_MULTIPLE_PCT_EXCEL:
            return {
                ...state,
                loading: true
            }
        case DOWNLOAD_MULTIPLE_PCT_EXCEL_SUCCESS:
            return {
                ...state,
                loading: false
            }
        case DOWNLOAD_MULTIPLE_PCT_PDF:
            return {
                ...state,
                loading: true
            }
        case DOWNLOAD_MULTIPLE_PCT_PDF_SUCCESS:
            return {
                ...state,
                loading: false
            }
        case PREVIEW_PCT_EMAIL:
            return{
                ...state,
                loading: true 
            }
        case PREVIEW_PCT_EMAIL_SUCCESS:
            return{
                ...state,
                previewEmail: {...action.payload.previewEmail, fromEmail: action.payload?.fromEmail || ""},
                previewPctPdfList: action.payload.previewPdfList,
                loading: false 
            }
        case SET_PREVIEW_PCT_EMAIL:
            return{
                ...state,
                previewEmail: action.payload,
                previewPctPdfList: []
            }
        case SEND_PCT_EMAIL:
            return {
                ...state,
                loading: true
            }
        case SEND_PCT_EMAIL_SUCCESS:
            return {
                ...state,
                loading: false
            }
        case CHANGE_SENT_PCT_RESULT:
            return {
                ...state,
                sentCnt: action.payload.sentCnt,
                unsubsEmails: action.payload.unsubsEmails,
                disableEmails: action.payload.disableEmails,
                sentIn24Emails: action.payload.sentIn24Emails,
                sentIn5DaysEmails: action.payload.sentIn5DaysCases,
                sentSuccess: 'Success',
            }
        case SET_PCT_SENT_SUCCESS:
            return {
                ...state,
                sentSuccess: action.payload,
            }
        case SET_UPGRADE_ALERT_MESSAGE:
            return {
                ...state,
                upgradeAlertMessage: action.payload
            }
        case SET_PCT_SETTINGS:
            return {
                ...state,
                isPctSearched: true,
                pctSearchSettings: action.payload.pctSearchSettings,
            }
        default:
            state = { ...state }
            break
    }
    return state
}

export default pctNotifier